import logo from "../../../../Assets/Images/brillJustjpg.png"
import PoppinsRegular from "../../../../Assets/Font/Merriweather,Poppins/Poppins/Poppins-Regular.ttf";
import jsPDF from 'jspdf'
import ReactDOMServer from 'react-dom/server'
import "./PremiumBreakup.css";
import "./Premiumpdf.css"


export const exportPremiumPdf = async (PremiumData, basicDetails, AVal, BVal, CVal) => {
    return new Promise(
        async (resolve, reject) => {
            try {


                let element = (
                    <>
                        {/* <!-- PDF PAGE ONE --> */}
                        <section className="pdf-container_Premium">
                          <div className="Header_title">
                            <h2>Motor Premium</h2>
                           <div>
                           </div>
                          </div>
                            {/* <div className="header-container-pdf_Premium">
                                <img src={logo} width={230} height={50} alt="" srcSet="" />
                                <div className="alliance_section">
                                    <p className="alliance_heading">
                                        Brilljust Solutions Private Limited
                                    </p>
                                    <p>
                                        ALT-F, Suncity Success Tower, <br /> Sec-65 Golf Course Ext.{" "}
                                        <br /> Road,Gurgaon (hr) :122005
                                    </p>
                                </div>
                            </div> */}
                            <div className="pdfCard">
                                <div className="card-content2">
                                    <h3 className="section-title_pdf">Basic Details</h3>
                                   <div className="bottom_boreder_line"></div>
                                    <div className="basic-details">
                                        {Object.entries(basicDetails).map(([key, value]) => (
                                            value ? (
                                                <div key={key} className="details-grid2_pdf">
                                                    <span>{key}</span>
                                                    <span className="premium_value">{(key=="Discount" || key=="NCB Discount")? `${value}%`:value}</span>
                                                </div>
                                            ) : null
                                        ))}
                                    </div>

                                    {(PremiumData["premium breakup"]["Total OD Premium"]) &&
                                        <div className="section">
                                            <h3 className="section-title_pdf">Own Damage Cover (A)</h3>
                                           <div className="bottom_boreder_line"></div>
                                            <div className="basic-details">
                                                <div className="details-grid2_pdf"><span>Own Damage</span> <span className="premium_value">₹  {parseInt(PremiumData["premium breakup"]["Basic OD Premium"])}</span></div>
                                                <div className="details-grid2_pdf"><span>Discount</span> <span className="premium_value">-₹ {parseInt(PremiumData["premium breakup"]["Discount"] || 0)}</span></div>
                                                <div className="details-grid2_pdf"><span>NCB Discount</span> <span className="premium_value">-₹ {parseInt(PremiumData["premium breakup"]["NCB Discount"] || 0)}</span></div>
                                                <div className="details-grid2_pdf total"><span>Total Own Damage</span > <span className="premium_value">₹ {parseInt(PremiumData["premium breakup"]["Total OD Premium"])}</span></div>
                                            </div>
                                            <div >

                                            </div>
                                        </div>

                                    }
                                    {
                                        (PremiumData["premium breakup"]["Total Addons Amount"]) &&
                                        <div className="section">
                                            <h3 className="section-title_pdf">Addon Coverage (B)</h3>
                                           <div className="bottom_boreder_line"></div>
                                            <div className="">
                                                {Object.entries(PremiumData["premium breakup"]["aaddons premium"]).map(([key, value]) => (
                                                    <div key={key} className="details-grid2_pdf">
                                                        <span >{key}</span>
                                                        <span className="premium_value">{parseInt(value)}</span>
                                                    </div>
                                                ))}

                                            </div>
                                            <div className="details-grid2_pdf total">
                                                <span>Total Addon Premium</span>
                                                <span>  ₹ {parseInt(PremiumData["premium breakup"]["Total Addons Amount"])}</span>
                                            </div>
                                        </div>

                                    }

                                    {PremiumData["premium breakup"]["Total TP Premium"] &&
                                        <div className="section">
                                            <h3 className="section-title_pdf">Third Party Cover (C)</h3>
                                           <div className="bottom_boreder_line"></div>
                                            <div className="details-grid2_pdf">
                                                <span>Basic TP</span>
                                                <span className="premium_value"> ₹ {parseInt(PremiumData["premium breakup"]["Basic TP Premium"])}</span>
                                            </div>
                                            <div className="details-grid2_pdf">
                                                <span>{`Legal Liability (LL)`}</span>
                                                <span className="premium_value"> ₹ {parseInt(PremiumData["premium breakup"]["Legal Liability"])}</span>
                                            </div>
                                            <div className="details-grid2_pdf total">
                                                <span>Total Third Party</span>
                                                <span> ₹ {parseInt(PremiumData["premium breakup"]["Total TP Premium"])}</span>
                                            </div>

                                        </div>
                                    }


                                    <div className="total-section">
                                        <h3 className="section-title_pdf">Total Premium</h3>
                                       <div className="bottom_boreder_line"></div>
                                        <div className="details-grid2_pdf">
                                            <span>Net Payable ({`${AVal}${BVal}${CVal}`})</span>
                                            <span className="premium_value"> ₹ {parseInt(PremiumData["premium breakup"]["Net Premium"])}</span>
                                        </div>
                                        <div className="details-grid2_pdf">
                                            <span>GST</span>
                                            <span className="premium_value"> ₹ {parseInt(PremiumData["premium breakup"]["Tax"])}</span>
                                        </div>
                                        <div className="details-grid2_pdf final-total">
                                            <span>Gross Premium </span>
                                            <span> ₹ {parseInt(PremiumData["premium breakup"]["Total Premium"])}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </>
                )

                const doc = new jsPDF('p', 'pt', 'a4', true)
                await doc.addFont(PoppinsRegular, 'Poppins', 'normal');
                doc.setFont('Poppins');

                doc.html(ReactDOMServer.renderToString(element), {
                    html2canvas: {
                        scale: 0.95,
                        useCORS: true,
                    },
                    processData: false,
                    contentType: false,
                    margin: [0, 20, 0, 20],
                    autoPaging: 'text',
                    callback: function (doc) {
                        doc.save("premiumCalculator" + '.pdf')
                        resolve()
                    }
                })
            } catch (error) {
                console.log(error)
                reject(error)
            }
        })
}